define('editor/render/iframe',['jquery', 'plugins/router'], function ($, router) {
    var viewmodel = function () {
        var self = this;
        self.router = router;

        self.activate = function (editorMap, closeFunc) {
            self.height = editorMap.height;
            self.width = editorMap.width;
            self.id = editorMap.id;
            self.closeFunc = closeFunc;
        };

        self.compositionComplete = function () {
            var iframeUrl = self.buildUrl(),
            iframe = $('iframe'),
            title = $('#preview-title'),
            shadowIframe = $('<iframe src="' + iframeUrl +
                '" style="height:' + self.height +
                'px;width:' + self.width +
                'px;border:0;margin-top:1em;"></iframe>');

            title.attr("style", "width: " + self.width + "px;");

            iframe.replaceWith(shadowIframe);
        };

        self.buildUrl = function() {
            var urlString = window.location.origin + '/editor/render/' + self.id +
                '?clean=true' +
                '&height=' + self.height +
                '&width=' + self.width;

            return urlString;
        };

        self.close = function() {
            self.closeFunc();
        };
    };

    return viewmodel;
});

